// Framework and third-party non-ui
import React, { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { MapContext } from 'contexts/MapContext';
import { signOut } from 'data/oauth';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import Popover from '@material-ui/core/Popover';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import Avatar from 'calcite-react/Avatar';
import UserIcon from 'calcite-ui-icons-react/UserIcon';
// JSON & Styles

// Third-party components (buttons, icons, etc.)

const UserPopover = ({userInfo}) => {
    const { setSidebarSelection, setClickedTab } = useContext(MapContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const history = useHistory();

  const useStyles = makeStyles((theme) => ({
        popoverPaper: {
            backgroundColor: '#ffffff',
            width: '70px'
        },
        userPopover: {
            borderColor: theme.palette.primary.main,
            border: '2px solid',
            fontFamily: 'Open Sans',
            fontWeight: 'bold',
            fontSize: '14px',
            marginLeft: '.1rem !important',
            marginRight: '.8rem !important',
            color: 'white !important',
            backgroundColor: theme.palette.primary.main,
            padding: '7.5px 8px',
            lineHeight: '24.5px',
            letterSpacing: '1px',
            textTransform: 'uppercase',
            size: '14px',
        },
        cancel: {
            fontFamily: 'Open Sans',
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: '14px',
            lineHeight: '20px',
            /* identical to box height, or 143% */
            display: 'flex',
            alignItems: 'center',
            textAlign: 'center',
            letterSpacing: '0.25px',
            padding: '7px',
            color: 'red',
            cursor: 'pointer',
            "&:hover, &:focus": {
            backgroundColor: "#E0E0E0"
            },
        },
        container: {
            display: 'flex',
            flexDirection: 'column',
            width: '220px',
            alignContent: 'center',
            },
        link: {
            fontFamily: 'Open Sans',
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: '14px',
            lineHeight: '20px',
            /* identical to box height, or 143% */
            display: 'flex',
            alignItems: 'center',
            textAlign: 'center',
            letterSpacing: '0.25px',
            padding: '7px',
            cursor: 'pointer',
            "&:hover, &:focus": {
                backgroundColor: "#E0E0E0"
            },
        },
        avatar: {
            bottom: '10px'
        }
    }));

    const getThumbnail = ({ credential, user }) => {
        return `${credential.server}/sharing/rest/community/users/${credential.userId}/info/${user.thumbnail}?token=${credential.token}`;
    };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const openProfile = (e) => {
      e.preventDefault();
      setSidebarSelection(['Profile']);
      setClickedTab('Profile');
      history.push('/details');
      handleClose();
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const classes = useStyles();

  return (
    <>
        {userInfo.user.thumbnail ? 
            <Avatar data-testid="UserPopoverAvatar" onClick={handleClick} size={36} src={getThumbnail(userInfo)} /> : 
            <Button color="secondary" className={classes.userPopover}
                data-testid="UserPopoverButton" onClick={handleClick}>
                {userInfo.user.firstName} <KeyboardArrowDownIcon />
            </Button>
        }
        <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose ={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
            classes={{paper: classes.popoverPaper}}
        >
            <div class={classes.container}>
                <div class={classes.link} onClick={openProfile}>Profile</div>
                <div class={classes.link} onClick={signOut}>Logout</div>
            </div>
        </Popover>
    </>
  );
};

export default UserPopover;
